module.exports = __webpack_public_path__ + "img/login-logo.a5c342fa.png";